import { PortableText } from "@portabletext/react";

// import assets
import RightLeaveSrc from "../../assets/images/svg-right.webp";
import LeftLeaveSrc from "../../assets/images/svg-left.webp";

const portableTextComponents = {
  block: {
    normal: ({ children }) => <p className="font-outfit">{children}</p>,
  },
  marks: {
    link: ({ value, children }) => (
      <a href={value?.href} className="title-link">
        {children}
      </a>
    ),
  },
};

const DescItem = ({ classname, component }) => {
  return (
    <div className={`desc-item ${classname || ""}`}>
      <img src={LeftLeaveSrc} className="leave-img" alt="left" />
      <div className="desc-text font-outfit">
        <PortableText value={component} components={portableTextComponents} />
      </div>
      <img src={RightLeaveSrc} className="leave-img" alt="right" />
    </div>
  );
};

export default DescItem;
